<template>
    <div class="team-page">
        <div class="top-menu">
            <div class="top">人工智能与机器视觉实验室</div>
            <div class="blank"></div>
            <div class="menu">
                <div class="menu-detail" @click="jumpToHome">首页</div>
                <div class="menu-detail" @click="jumpToTutor">导师风采</div>
                <div class="menu-detail" @click="jumpToTeam">科研团队</div>
                <div class="menu-detail" @click="jumpToPaper">论文成果</div>
                <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
                <div class="menu-detail" @click="jumpToDownload">文件下载</div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contribution </div>
            </div>
        </div>

        <div class="blank"></div>
        <div class="page-content">
            <div class="paper-block">
                <div class="paper-block-title">National Copyright Administration of the People's Republic of China, Computer Software Copyright Level Certificate:</div>
                <div class="paper-block-word">
                    <div class="paper-block-word-item">
                        [1] <b>Tao Lei*</b>, Jian Su, Linxiangyi Li. An AI based structured report generation system for liver function evaluation, No. 2023SR0517660, 2023.05.05.                     
                        </div>
                    <div class="paper-block-word-item">
                        [2] <b>Tao Lei*</b>, Sijia Wen, Yi Wang, Wenbiao Song. Abdominal multi organ medical image segmentation software V1.0, No. 2023SR0945429, 2023.06.05.                     
                        </div>
                    <div class="paper-block-word-item">
                        [3] Minfei Lu, <b>Tao Lei*</b>, et al. Liver and Liver Tumor Medical Image Segmentation Software V1.0. Shaanxi University of Science and Technology, Registration No. 2021SR0911843, Registration Date: 2021.6.17.                     
                        </div>
                </div>
             </div>
        </div>

            <div class="paper-block">
                <div class="paper-block-title">China National Intellectual Property Administration:</div>
                    <div class="paper-block-word">
                    <div class="paper-block-word-item">
                        [1] <b>Tao Lei*</b>, et al. Liver Segmentation Method Based on Spatial Multi-scale U-net with Super Pixel Correction. Chinese Invention Patent, Patent No. ZL201910605862.X, Granted: 2022.9.30.                     
                        </div>

                    <div class="paper-block-word-item">
                        [2] <b>Tao Lei*</b>,  et al. Automatic Measurement Method for Porous Material Holes Based on Scanning Electron Microscope Image Segmentation. Chinese Invention Patent, Patent No. ZL202010347215.6, Granted: 2023.3.24.                     
                        </div>

                    <div class="paper-block-word-item">
                        [3] <b>Tao Lei*</b>, et al. Landslide Identification Method Based on Combination of Symmetric Deep Network and Multi-scale Pooling. Chinese Invention Patent, Patent No. ZL 201811511696.9, Granted: 2023.3.24.                     
                        </div>

                    <div class="paper-block-word-item">
                        [4] <b>Tao Lei*</b>, et al. Remote Sensing Image Unsupervised Change Detection Method Based on Siamese Network Structure. Chinese Invention Patent, Patent No. ZL 202010535407.X, Granted: 2023.2.28.                     
                        </div>

                    <div class="paper-block-word-item">
                        [5] <b>Tao Lei*</b>, et al. Convolutional Neural Network and Image Segmentation Method Based on Four-Branch Attention Mechanism. Chinese Invention Patent, Patent No. ZL202110404815.6, Granted: 2023.4.7.
                        </div>

                    <div class="paper-block-word-item">
                        [6] Dong Zhang, <b>Tao Lei*</b>, et al. Liver Surface Smoothness Measuring Method Based on Differential Curvature. Chinese Invention Patent, Patent No. ZL202110757748.6, Granted: 2023.9.19.  
                        </div>
                    
                    <div class="paper-block-word-item">
                        [7] <b>Tao Lei*</b>, et al. High Resolution Remote Sensing Images Semantic Segmentation Method Based on Multi-scale Attention Fusion Network. Chinese Invention Patent, Patent No. ZL202110528206.1, Granted: 2023.8.22.
                        </div>

                    <div class="paper-block-word-item">
                        [8] <b>Tao Lei*</b>,  et al. Segmentation Method Based on Deformable Context Encoding Network Model for Liver and Liver Tumor. Chinese Invention Patent, Patent No. ZL202011058875.9, Granted: 2023.9.15.
                        </div>

                    <div class="paper-block-word-item">
                        [9] <b>Tao Lei*</b>,  et al. Color Image Filtering Method Based on Hypercomplex Description. Chinese Invention Patent, Patent No. ZL201310014234.7, Granted: 2015.7.15.
                        </div>

                    <div class="paper-block-word-item">
                        [10] <b>Tao Lei*</b>, et al. Unsupervised Color Image Segmentation Method Based on Watershed Transform. Chinese Invention Patent, Patent No. ZL201410625139.5, Granted: 2017.3.22.
                        </div>

                    <div class="paper-block-word-item">
                        [11] <b>Tao Lei*</b>, et al. Micro-gesture Recognition Method Based on Panoramic 3D Images. Chinese Invention Patent, Patent No. ZL201810306498.2, Granted: 2021.7.13.
                        </div>

                    <div class="paper-block-word-item">
                        [12] Jie Kang, <b>Tao Lei*</b>, et al. Interactive Liver Segmentation Method Based on Geodesic Distance and V-net. Chinese Invention Patent, Patent No. ZL202011155526.9, Granted: 2023.4.7.
                        </div>

                    <div class="paper-block-word-item">
                        [13] <b>Tao Lei*</b>, et al. Ceramic Material Grain Segmentation Algorithm Driven by Data and Model Combination. Chinese Invention Patent, Patent No. ZL202010836869.5, Granted: 2023.6.23.
        quot            </div>

                    <div class="paper-block-word-item">
                        [14] Xiaogang Du, <b>Tao Lei*</b>, et al. Diffeomorphic Non-rigid Registration Algorithm Based on Hierarchical Neighborhood Spectral Features. Chinese Invention Patent, Patent No. ZL202010697148.0, Granted: 2023.6.23.
                        </div>

                    <div class="paper-block-word-item">
                        [15] <b>Tao Lei*</b>, et al. Dense Crowd Counting Method Based on Multi-scale Feature Pyramid Network Chinese Invention Patent, Patent No. ZL 202110293926.4, Granted: 2024.2.1.
                        </div>
                </div>
            </div>           
        <div>            
    </div>
             <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>
    </div>
</template>

<script>
    export default {
    data() {
        return {
            path: process.env.BASE_URL,
            CiT_Net: "../download/CiT_Net.pdf",
            Def_Net: "../download/DefED-net.pdf",
            TCDS: "../download/TCDS.pdf",
            USSFC: "../download/Ultralightweight_SpatialSpectral_Feature.pdf",
            landslide: "../download/Landslide.pdf",
            DESSN: "../download/DESSN.pdf",
            ASENet: "../download/ASENet.pdf",
            SDC_SSL: "../download/SDC-SSL.pdf",
            AFCF: "../download/AFCF.pdf",
            SGUNet: "../download/SGUNet.pdf",
            AMRR: "../download/AMRR.pdf",
            medicalsurvey: "../download/Medical-image-segmentation-survey.pdf",
            SFFCM: "../download/SFFCM.pdf",
            FRFCM: "../download/FRFCM.pdf",
            SE_MGMM: "../download/SE-MGMM.pdf",
            a_conditionally_invariant_mathematical_morphological: "../download/a conditionally invariant mathematical morphological.pdf",
            research_progress_on_image_segmentation_based_on_fuzzy_clustering: "../download/research progress on image segmentation based on fuzzy clustering.pdf",
            Grain_segmentation_of_ceramic_materials: "../download/Grain segmentation of ceramic materials.pdf",
            FRSC: "../download/FRSC.pdf",
        };
    },
        methods: {

            jumpToHome() {
                this.$router.push({
                    name: "home",
                });
            },
            jumpToTutor() {
                this.$router.push({
                    name: "tutor",
                });
            },
            jumpToTeam() {
                this.$router.push({
                    name: "team",
                });
            },
            jumpToPaper() {
                this.$router.push({
                    name: "paper",
                });
            },
            jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
            jumpToDownload() {
                this.$router.push({
                    name: "download",
                });
            },
            jumpToInnovation() {
                this.$router.push({
                    name: "innovation",
                });
            },
            jumpToService() {
                this.$router.push({
                    name: "service",
                });
            },
            jumpToInfluence_Contribution() {
                this.$router.push({
                    name: "influence_contribution",
                });
            },
        },
    };
</script>

<style scoped>
    .tutor-page {
        width: 100%;
        height: 100%;
        background-color: #fffef9;
        display: flex;
        flex-direction: column;
    }

    .top-menu {
        width: 100%;
    }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }

  .blank {
    background-color: #dfe8ed;
    height: 3px;
    width: 100%;
  }


    .menu-detail:hover {
        background-color: #dfe8ed;
    }

    .page-content {
        width: 100%;
    }

    .paper-block {
        border: 1px solid #517b95;
        margin: 10px 100px;
    }

    .paper-block-title {
        background-color: #7494b1;
        color: #ffffff;
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        padding-left: 20px;
        letter-spacing: 3px;
    }

    .paper-block-word {
        line-height: 28px;
        padding-left: 20px;
        font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
        font-size: 18px;
    }

    .paper-block-word-item {
        padding-bottom: 10px;
    }

    .icon-yuandianzhong {
        color: #8a9098;
    }
    .footer{
        height: 70px;
        background-color: 	#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
    }
</style>>